export default () => ({
  mobileVersion: false,
  pageName: "project",
  search: false,
  searchWrite: false,
  mobileMenuIsOpen: false,
  headerBannerScrollActive: false,
  showMoreAgendas: false,
  selectedGuest: "",
  scrollTop: false,
  isHeaderScrollBanner: false,
  langChange: false,
  tagTypes: [],
  searchVal: "",
  roundSliderIndex: 0,
  roundSliderPaginationIndex: null,
  goToOrder: false,
  bookSpaceItem: null,
  offerListContent: null,
  offerSearchDate: null
});
